export enum EConversionSIToImperial {
    m_to_ft = 3.28083,
    mm_to_in = 0.03937,

    m2_to_ft2 = 10.763845,
    mm2_to_in2 = 0.00155,
    m3_to_ft3 = 35.314347,
    kN_to_lbf = 224.8089,
    kNm_to_lbfft = 68.521959,

    kN_m_to_lbf_ft = 737.56,

    Nm2_to_lbfft2 = 0.020885,
    kNm3_to_lbfft3 = 6.242795,
    kgm2_to_lbfft2 = 0.028783,

    m_to_in = 39.3701,
    m3s_to_ft3s = 35.3147,
    ms_to_fts = 3.28084,
    Nm3_to_lbft3 = 6.4231142857,
    m3sm_to_ft3sft = 10.7639,

    MPa_to_lbfft2 = 0.020885,

    MPa_to_psi = 145.03773800722,
    MPa_to_ksi = 0.1450377377,
}

export enum EConversionImperialToSI {
    ft_to_m = 1 / 3.28084,
    in_to_mm = 1 / 0.0393701,
    in_to_m = 1 / 39.3701,
    ft2_to_m2 = 1 / 10.7639,
    in2_to_mm2 = 1 / 0.00155,
    ft3_to_m3 = 1 / 35.3147,
    lbf_to_kN = 1 / 224.8089,
    lbfft_to_kNm = 1 / 68.5218,
    lbf_ft_to_kN_m = 1 / 737.56,
    lbfft2_to_Nm2 = 1 / 0.0208854,
    lbfft3_to_kNm3 = 1 / 6.36588,
    ft3s_to_m3s = 1 / 35.3147,
    fts_to_ms = 1 / 3.28084,
    lbft3_to_Nm3 = 1 / 6.4231142857,
    ft3sft_to_m3sm = 1 / 10.7639,
}

export const conversionLabel = {
    m_ft: ['m', 'ft'],
    mm_ftft: ['m/m', 'ft/ft'],
    mm_in: ['mm', 'in'],
    mmy_iny: ['mm/y', 'in/y'],
    m_in: ['m', 'in'],
    m2_ft2: ['m²', 'ft²'],
    mm2_in2: ['mm²', 'in²'],
    m3_ft3: ['m³', 'ft³'],
    kN_lbf: ['kN', 'lbf'],
    kNm_lbfft: ['kN/m', 'lbf/ft'],
    kN_m_lbf_ft: ['kN*m', 'lbf*ft'],
    Nm2_lbfft2: ['N/m²', 'lbf/ft²'],
    kNm3_lbfft3: ['kN/m³', 'lbf/ft³'],
    m3s_ft3s: ['m³/s', 'ft³/s'],
    ms_fts: ['m/s', 'ft/s'],
    Nm3_lbfft3: ['N/m³', 'lbf/ft³'],
    m3sm_ft3sft: ['m³/s/m', 'ft³/s/ft'],
    kgm2_lbfft2: ['kg/m²', 'lb/ft²'],
    kgm3_lbfft3: ['kg/m³', 'lb/ft³'],
    deg: ['°', '°'],
    mpa: ['MPa', 'lbf/ft²'],
    mpa_mpa: ['MPa', 'MPa'],
    mpa_psi: ['MPa', 'psi'],
    mpa_ksi: ['MPa', 'ksi'],
    years: ['years', 'years'],
};

export const convertTo = (value: number, type: EConversionSIToImperial | EConversionImperialToSI): number => {
    return value * type;
};
